import {Component, OnInit, ViewEncapsulation, Input} from "@angular/core";
import {BaseComponent} from "../../../../../common/components/base.component";
import {HubApiService} from "../../../../../services/hub.api.service";
import {ModalService} from "../../../../../common/services/modal.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {EditCityModalComponent} from "../../../edit.city.modal/edit.city.modal.component";
import {EditCityModalActions} from "../../../edit.city.modal/edit.city.modal.provider";
import {HubFeed} from "../../../../../models/hub/hub.feed";
import {ButtonTriggerEvent} from "../../../../../common/components";
import {
  SearchGooglePlaceResultModalActions,
  SearchGooglePlaceResultModalData
} from "./search.google.place.result.modal/search.google.place.result.modal.provider";
import {
  SearchGooglePlaceResultModalComponent
} from "./search.google.place.result.modal/search.google.place.result.modal.component";
import {HubGooglePlaceBasicData} from "../../../../../models/hub/hub.google.place.data";
import {HubPlace} from "../../../../../models/hub/hub.place";

@Component({
  selector: 'ig-search-google-place',
  templateUrl: './search.google.place.component.html',
  styleUrls: ['./search.google.place.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchGooglePlaceComponent extends BaseComponent implements OnInit {
  @Input() public enabled = false;
  @Input() public hubName: string;
  public placeName: string;
  public blockedCategories: string;
  public placeFormGroup: FormGroup;

  constructor(private router: Router,
              private hubApiService: HubApiService,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private modalService: ModalService,) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;

    this.placeFormGroup = this.formBuilder.group({
      'placeName': [null, [Validators.required]],
    });
  }

  public async search($event) {
    const searchPlace = this.hubApiService.searchGooglePlaceByName(this.hubName, this.placeName).toPromise();
    const getBlocked = this.hubApiService.getGooglePlaceBlockedCategories(this.hubName).toPromise();
    const getAllowedPlaceCategories = this.hubApiService.getAllowedPlaceCategories(this.hubName).toPromise();

    const result = await Promise.all([searchPlace, getBlocked, getAllowedPlaceCategories]);
    $event.complete();

    this.blockedCategories = result[1] ? result[1].value : '';

    let actions = <SearchGooglePlaceResultModalActions>{
      confirm: (event: ButtonTriggerEvent, data: any) => {
      }
    };
    this.modalService.show({
      component: SearchGooglePlaceResultModalComponent,
      providers: [
        {
          provide: SearchGooglePlaceResultModalActions,
          useValue: actions
        },
        {
          provide: SearchGooglePlaceResultModalData,
          useValue: new SearchGooglePlaceResultModalData(result[0], this.hubName, this.blockedCategories, result[2])
        },
      ],
      panelClass: 'width-modal-90p'
    });
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.component.ts